export const CANCEL_LABEL = 'Abbrechen';
export const OK_LABEL = 'Übernehmen';
export const SHORT_TEXT_LABEL = 'Kurztext';
export const MANUFACTURER_LABEL = 'Hersteller';
export const ARTICLE_NUMBER_LABEL = 'Artikelnummer';
export const QUANTITY_LABEL = 'Anzahl';
export const PRICE_LABEL = 'Preis';
export const UNIT_LABEL = 'Einheit';
export const ITEM_TYPE_LABEL = 'Positionsart';
export const APPLY_TO_LABEL = 'Anwenden auf';
export const REFERENCE_VALUE_LABEL = 'Bezugswert';
export const TOTAL_LABEL = 'Gesamt';
export const SELECTED_ITEMS_LABEL = 'Ausgewählte Positionen';
export const START_POSITION_LABEL = 'Startposition';
export const END_POSITION_LABEL = 'Endposition';
export const ITEM_LABEL = 'Artikel';
export const CREATE_LABEL = 'Erstellen';
export const CREATE_TASK_LABEL = 'Auftrag erstellen';
export const CREATE_OFFER_LABEL = 'Angebot erstellen';
export const CREATE_INVOICE_LABEL = 'Rechnung erstellen';
export const SHOPPING_CART_LABEL = 'Warenkorb';
export const NEW_ITEM_LABEL = 'Neuer Artikel';
export const NEW_TEXT_ITEM_LABEL = 'Neue Textposition';
export const NEW_SURCHARGE_DISCOUNT_LABEL = 'Neue Rabatt-/Zuschlagposition';
export const ARTICLE_CATALOG_LABEL = 'Aus Artikelstamm';
export const DISCOUNT_LABEL = 'Rabatt';
export const SURCHARGE_LABEL = 'Zuschlag';
export const DRAG_AND_DROP_LABEL = 'Position per Drag and Drop verschieben';
export const ADD_ITEM_LABEL = 'Position hinzufügen';
export const EDIT_ITEM_LABEL = 'Position bearbeiten';
export const DELETE_ITEM_LABEL = 'Position löschen';
export const DELETE_ITEM_CONFIRMATION_LABEL =
  'Wollen sie den Artikel aus dem Warenkorb löschen?';
export const PLUS_MWST_LABEL = 'plus $$% MwSt:';
export const SUM_LABEL = 'Summe';
export const ARTICLE_CATALOG_PAGE_LABEL = 'Artikelkatalog';
export const ARTICLE_CATALOG_PAGE_SUBTITLE_LABEL =
  'Alle Artikel auf einen Blick';
export const NET_EP_LABEL = 'Netto Einzelpreis';
export const NET_GP_LABEL = 'Gesamtpreis';
export const VAT_SHORT_LABEL = 'MwSt %';
